/* eslint-disable react/require-default-props,react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import createMarkup from '../helpers/createMarkup';
import Avatar from '../common/Avatar';
import SoftBadge from '../common/SoftBadge';
import logo from '../../../assets/img/icons/ciat.png';
import { foreignPropType } from '../../../constants/backend/propTypes';
import { convertStringToDate } from '../../../common/funcs';
import { longFormat } from '../../../constants/date';

function Notification({
  id,
  author,
  title,
  message_type: messageType,
  read,
  flush,
  created,
}) {
  return (
    <Link
      className={classNames(
        'notification',
        { 'notification-unread': !read, 'notification-flush': flush },
      )}
      to="#!"
    >
      <Avatar src={logo} size="s" rounded="soft" />
      <div className="flex-1 ms-2">
        <Link
          to={`/email/email-detail/${id}`}
          className={classNames('stretched-link inbox-link', {
            'fw-bold': !read,
          })}
        >
          {author.repr}
        </Link>
        {messageType === 1 && (
        <SoftBadge bg="info" className="ms-2">
          інфо
        </SoftBadge>
        )}
        {messageType === 2 && (
        <SoftBadge bg="danger" className="ms-2">
          важливо
        </SoftBadge>
        )}
      </div>
      <div className="notification-body">
        <p className="mb-1" dangerouslySetInnerHTML={createMarkup(title)} />
        <span className="notification-time">
          {convertStringToDate(created).toLocaleString('uk', longFormat)}
        </span>
      </div>
    </Link>
  );
}

Notification.propTypes = {
  id: PropTypes.string,
  read: PropTypes.bool,
  title: PropTypes.string,
  flush: PropTypes.bool,
  message_type: PropTypes.number,
  author: foreignPropType,
  created: PropTypes.string,
};

Notification.defaultProps = {
  read: true,
  flush: false,
  message_type: 0,
};

export default Notification;
